import { ICatalogObject } from "../types/catalogPage";

export const getUniqueProperties = (properties: ICatalogObject[]) => {
  return properties.reduce((a: ICatalogObject[], b) => {
    const existingProperty = a.find((property) => property.name === b.name);

    if (!existingProperty) {
      a.push(b);
      return a;
    } else if (b.price.usd < existingProperty.price.usd) {
      a[a.indexOf(existingProperty)] = b;
      return a;
    }
    return a;
  }, []);
};
